import * as Yup from 'yup';
import { useMemo } from 'react';
import { SuccessStory } from '../../../@types/successStory';

export const SuccessStorySchema = (currentStory?: SuccessStory) => {
  const NewSuccessStorySchema = Yup.object().shape({
    name: Yup.string().min(2).required('Name is required'),
    name_ar: Yup.string(),
    title: Yup.string(),
    title_ar: Yup.string(),
    story: Yup.string().min(3).required('Story is required'),
    story_ar: Yup.string(),
    order: Yup.number().typeError('Order must be a number').required('Order is required'),
    active: Yup.boolean(),
    images: Yup.array().of(Yup.string()),
    type: Yup.string().oneOf(['story', 'activity']),
    date: Yup.string(),
  });

  const defaultValues: any = useMemo(
    () => ({
      name: currentStory?.name || '',
      name_ar: currentStory?.name_ar || '',
      title: currentStory?.title || '',
      title_ar: currentStory?.title_ar || '',
      story: currentStory?.story || '',
      story_ar: currentStory?.story_ar || '',
      order: currentStory?.order ?? 0,
      active: currentStory?.active ?? true,
      images: currentStory?.images || [],
      type: currentStory?.type || 'story',
      date: currentStory?.date ? String(currentStory.date).slice(0, 10) : '',
    }),
    [currentStory]
  );

  return { NewSuccessStorySchema, defaultValues };
};
